export default "__VITE_ASSET__Cb9OR1Az__"